var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHpLoginLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7552_13873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C11.8807 24 11.7619 23.9978 11.6434 23.9944L14.0958 17.2545H17.4708C18.0631 17.2545 18.7134 16.7991 18.916 16.2427L21.5767 8.93466C22.0119 7.73818 21.3266 6.75926 20.0534 6.75926H15.3713L11.4427 17.5546H11.4412L9.21403 23.6742C3.93023 22.418 0 17.6682 0 12C0 6.49529 3.70668 1.85674 8.76014 0.442977L6.46205 6.75926H6.4614L2.64106 17.2545L5.1843 17.2547L8.43327 8.33638H10.3446L7.09562 17.2547L9.63789 17.2552L12.6656 8.93466C13.1011 7.73818 12.4157 6.75926 11.1438 6.75926H9.00592L11.4607 0.0126111C11.6396 0.00469443 11.8192 0 12 0C18.6274 0 24 5.37257 24 12C24 18.6273 18.6274 24 12 24ZM19.2607 8.32995H17.3499L14.6739 15.6721H16.5848L19.2607 8.32995Z",
    fill: "#027AAE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7552_13873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpLoginLogo);
export default __webpack_public_path__ + "static/media/hpLoginLogo.2b1ac783304bbea8beedbf7a97dfde4d.svg";
export { ForwardRef as ReactComponent };